import { forwardRef } from 'react';

import Link from '@mui/material/Link';
import Box, { BoxProps } from '@mui/material/Box';

import { useParams } from 'src/routes/hooks';
import { RouterLink } from 'src/routes/components';

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
  version?: 'white' | 'blue';
  width?: number | string;
  height?: number | string;
  url?: string;
  customLogo?: string;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  (
    {
      disabledLink = false,
      version = 'white',
      height,
      url = '/home',
      width,
      customLogo,
      sx,
      ...other
    },
    ref
  ) => {
    const {bu, event} = useParams();
    const logo = (
      <Box
        ref={ref}
        component="img"
        src={customLogo || ''}
        sx={{
          width: width || '100%',
          height: height || 'auto',
          cursor: 'pointer',
          ...sx,
        }}
        {...other}
      />
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} href={`/${bu}/${event}${url}`} sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  }
);

export default Logo;
